export default __webpack_public_path__ + "static/media/IMG_6414.1790777a.jpeg";